import { createContext, useContext, useEffect, useMemo, useState } from "react";

const CartContext = createContext(null);
const KEY = "pc_cart";

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem(KEY)) || [];
    } catch {
      return [];
    }
  });

  useEffect(() => {
    localStorage.setItem(KEY, JSON.stringify(items));
  }, [items]);

  const add = (product, variant = "", quantity = 1, unitPriceCents = 0) => {
    const key = `${product.id}|${variant}`;
    setItems((prev) => {
      const existing = prev.find((i) => i.key === key);
      if (existing) {
        return prev.map((i) => (i.key === key ? { ...i, quantity: Math.min(i.quantity + quantity, 20) } : i));
      }
      return [
        ...prev,
        {
          key,
          product_id: product.id,
          name: product.name,
          variant,
          quantity,
          unit_price_cents: unitPriceCents,
          image: product.image || "",
          kind: product.kind || "Physical Product",
        },
      ];
    });
  };

  const setQty = (key, q) =>
    setItems((prev) =>
      q <= 0 ? prev.filter((i) => i.key !== key) : prev.map((i) => (i.key === key ? { ...i, quantity: Math.min(q, 20) } : i))
    );
  const remove = (key) => setItems((prev) => prev.filter((i) => i.key !== key));
  const clear = () => setItems([]);

  const count = useMemo(() => items.reduce((a, i) => a + i.quantity, 0), [items]);
  const subtotal = useMemo(() => items.reduce((a, i) => a + i.unit_price_cents * i.quantity, 0), [items]);

  return <CartContext.Provider value={{ items, add, setQty, remove, clear, count, subtotal }}>{children}</CartContext.Provider>;
}

export const useCart = () => useContext(CartContext);

export const fmtPrice = (cents) => {
  if (!cents) return "Price TBA";
  const dollars = cents / 100;
  return `$${dollars % 1 === 0 ? dollars : dollars.toFixed(2)}`;
};
